import { useMemo } from 'react';
import { MButton } from '@Components/Base';
import { CANCELLED_STATUSES } from '@Constants';

import styles from './footer-actions.module.css';

interface FooterActionsProps {
  status: string;
  disabledCancelForm: boolean;
  disabledDeleteForm: boolean;
  disabledSubmitForm: boolean;
  handleDeleteRequest: () => void;
  handleSubmitRequest: () => void;
  handleCancelRequest: () => void;
}

const FooterActions: React.FC<FooterActionsProps> = ({
  status,
  disabledCancelForm,
  disabledDeleteForm,
  disabledSubmitForm,
  handleCancelRequest,
  handleDeleteRequest,
  handleSubmitRequest,
}) => {
  const renderActionButtons = useMemo(() => {
    const isCancelledStatus = CANCELLED_STATUSES.includes(
      status.toLocaleLowerCase()
    );
    if (isCancelledStatus) {
      return null;
    }

    if (status === 'Open') {
      return (
        <>
          <MButton
            onClick={handleDeleteRequest}
            danger
            disabled={disabledDeleteForm}
          >
            Delete Request
          </MButton>
          <MButton
            onClick={handleSubmitRequest}
            type="primary"
            disabled={disabledSubmitForm}
          >
            Submit
          </MButton>
        </>
      );
    }

    return (
      <MButton
        onClick={handleCancelRequest}
        type="secondary"
        disabled={disabledCancelForm}
      >
        Cancel Request
      </MButton>
    );
  }, [status]);

  return <div className={styles.footerActions}>{renderActionButtons}</div>;
};

export default FooterActions;
